/**
 * ROYAL FIX HOME — shared constants.
 * Single source of truth for values referenced across multiple features
 * (search filters, add-property form, admin dashboards, etc.).
 */

export const APP_NAME = "Royal Fix Home";

export const REGION_NAME = "Qashqadaryo viloyati";

export const DISTRICTS = [
  "Qarshi",
  "Shahrisabz",
  "Kitob",
  "Koson",
  "Kasbi",
  "Nishon",
  "G'uzor",
  "Chiroqchi",
  "Dehqonobod",
  "Kamashi",
  "Muborak",
  "Mirishkor",
  "Yakkabog'",
  "Qamashi",
];

export const PROPERTY_TYPES = [
  "Kvartira",
  "Hovli uy",
  "Tomorqa uy",
  "Tijorat maydoni",
];

export const LISTING_PURPOSE = {
  SALE: "sale",
  RENT: "rent",
};

export const LISTING_STATUS = {
  PENDING: "pending", // awaiting admin moderation
  ACTIVE: "active", // approved and visible in search
  REJECTED: "rejected",
  ARCHIVED: "archived", // sold / rented / expired
};

export const USER_ROLES = {
  USER: "user",
  REALTOR: "realtor",
  ADMIN: "admin",
};

export const PREMIUM_PLANS = {
  BASIC: { id: "basic", days: 7 },
  STANDARD: { id: "standard", days: 14 },
  EXTENDED: { id: "extended", days: 30 },
};
